/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StoreAggregatorOnboarding } from '../../models/store-aggregator-onboarding';
import { StoreAggregatorOnboardingRequest } from '../../models/store-aggregator-onboarding-request';

export interface StoresStoreIdOnboardingAggregatorsAggregatorIdPut$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
  aggregatorId: string;
      body: StoreAggregatorOnboardingRequest
}

export function storesStoreIdOnboardingAggregatorsAggregatorIdPut(http: HttpClient, rootUrl: string, params: StoresStoreIdOnboardingAggregatorsAggregatorIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreAggregatorOnboarding>> {
  const rb = new RequestBuilder(rootUrl, storesStoreIdOnboardingAggregatorsAggregatorIdPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
    rb.path('aggregatorId', params.aggregatorId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StoreAggregatorOnboarding>;
    })
  );
}

storesStoreIdOnboardingAggregatorsAggregatorIdPut.PATH = '/stores/{storeId}/onboarding/aggregators/{aggregatorId}';
